import { ElementRef, EventEmitter } from '@angular/core';
import { ControlValueAccessor } from "@angular/forms";
var NewTimePickerComponent = /** @class */ (function () {
    // dropdownMinuteSteps = ['00', '15', '30', '45'];
    function NewTimePickerComponent(eRef, settings) {
        this.eRef = eRef;
        this.settings = settings;
        this.timeChange = new EventEmitter();
        this.showTitle = true;
        this.minTime = ''; // Minimum time filter (e.g., "09:00" or "09:00 AM")
        this.minuteSteps = 15;
        this.maxTime = '';
        this.allowTyping = true;
        this.hour = '00';
        this.minute = '00';
        this.meridian = 'AM';
        this.showMeridian = true;
        this.showDropdown = false;
        this.isTyping = false;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.showMeridianDropdown = false;
        var intlSettings = this.settings.getIntlSettings();
        this.showMeridian = parseInt(intlSettings['time']) === 0;
    }
    Object.defineProperty(NewTimePickerComponent.prototype, "time", {
        set: function (value) {
            if (!value || typeof value !== 'string') {
                this.applyDefaultTime();
                return;
            }
            else {
                this.applyIncomingTime(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    NewTimePickerComponent.prototype.writeValue = function (val) {
        if (val) {
            this.applyIncomingTime(val);
        }
    };
    NewTimePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    NewTimePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    NewTimePickerComponent.prototype.updateValue = function (newValue) {
        this.value = newValue;
        this.onChange(newValue);
        this.onTouched();
    };
    NewTimePickerComponent.prototype.ngOnInit = function () {
        var intlSettings = this.settings.getIntlSettings();
        this.showMeridian = parseInt(intlSettings['time']) === 0;
    };
    Object.defineProperty(NewTimePickerComponent.prototype, "dropdownMinuteSteps", {
        get: function () {
            var steps = [];
            for (var m = 0; m < 60; m += this.minuteSteps) {
                steps.push(m.toString().padStart(2, '0'));
            }
            return steps;
        },
        enumerable: true,
        configurable: true
    });
    NewTimePickerComponent.prototype.handleClickOutside = function (event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showDropdown = false;
            this.isTyping = false;
            this.showMeridianDropdown = false;
        }
    };
    Object.defineProperty(NewTimePickerComponent.prototype, "meridianList", {
        get: function () {
            var _this = this;
            if (!this.minTime && !this.maxTime)
                return ['AM', 'PM'];
            var validMeridians = [];
            var _loop_1 = function (mer) {
                var hourOrder = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
                var hasValidTime = hourOrder.some(function (h) {
                    return _this.dropdownMinuteSteps.some(function (m) {
                        var minutes = _this.parse12HourTimeToMinutes(h, parseInt(m), mer);
                        var validMin = !_this.minTime || minutes >= _this.parseTimeToMinutes(_this.minTime);
                        var validMax = !_this.maxTime || minutes <= _this.parseTimeToMinutes(_this.maxTime);
                        return validMin && validMax;
                    });
                });
                if (hasValidTime)
                    validMeridians.push(mer);
            };
            for (var _i = 0, _a = ['AM', 'PM']; _i < _a.length; _i++) {
                var mer = _a[_i];
                _loop_1(mer);
            }
            return validMeridians;
        },
        enumerable: true,
        configurable: true
    });
    NewTimePickerComponent.prototype.emitFinalValue = function () {
        var formatted = this.showMeridian
            ? this.hour + ":" + this.minute + " " + this.meridian
            : this.hour + ":" + this.minute;
        this.timeChange.emit(formatted);
        this.updateValue(formatted);
    };
    Object.defineProperty(NewTimePickerComponent.prototype, "displayValue", {
        get: function () {
            return this.showMeridian
                ? this.hour + ":" + this.minute + " " + this.meridian
                : this.hour + ":" + this.minute;
        },
        enumerable: true,
        configurable: true
    });
    NewTimePickerComponent.prototype.applyIncomingTime = function (value) {
        value = value.trim();
        var isIncoming12Hr = /^(0?\d|1[0-2]):[0-5]\d\s?(AM|PM)$/i.test(value);
        var isIncoming24Hr = /^([01]?\d|2[0-3]):[0-5]\d$/.test(value);
        var isComponent12Hr = this.showMeridian;
        if (!isIncoming12Hr && !isIncoming24Hr) {
            this.applyDefaultTime();
            return;
        }
        if (isIncoming12Hr && !isComponent12Hr) {
            value = this.convert12To24(value);
        }
        if (!isIncoming12Hr && isComponent12Hr) {
            value = this.convert24To12(value);
        }
        this.setInitialTime(value);
    };
    NewTimePickerComponent.prototype.setInitialTime = function (value) {
        if (this.showMeridian) {
            var match = value.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
            if (match) {
                this.hour = match[1].padStart(2, '0');
                this.minute = match[2].padStart(2, '0');
                this.meridian = match[3].toUpperCase();
            }
        }
        else {
            var match = value.match(/^(\d{1,2}):(\d{2})$/);
            if (match) {
                this.hour = match[1].padStart(2, '0');
                this.minute = match[2].padStart(2, '0');
            }
        }
    };
    NewTimePickerComponent.prototype.convert12To24 = function (value) {
        var match = value.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
        if (!match)
            return value;
        var hour = parseInt(match[1], 10);
        var minute = match[2];
        var mer = match[3].toUpperCase();
        if (mer === 'PM' && hour !== 12)
            hour += 12;
        if (mer === 'AM' && hour === 12)
            hour = 0;
        return hour.toString().padStart(2, '0') + ":" + minute;
    };
    NewTimePickerComponent.prototype.convert24To12 = function (value) {
        var match = value.match(/^(\d{1,2}):(\d{2})$/);
        if (!match)
            return value;
        var hour = parseInt(match[1], 10);
        var minute = match[2];
        var mer = 'AM';
        if (hour >= 12) {
            mer = 'PM';
            if (hour > 12)
                hour -= 12;
        }
        else if (hour === 0) {
            hour = 12;
        }
        return hour.toString().padStart(2, '0') + ":" + minute + " " + mer;
    };
    NewTimePickerComponent.prototype.applyDefaultTime = function () {
        this.hour = '00';
        this.minute = '00';
        if (this.showMeridian) {
            this.meridian = 'AM';
            this.hour = '12';
        }
        this.emitFinalValue();
    };
    Object.defineProperty(NewTimePickerComponent.prototype, "timeList", {
        get: function () {
            var list = [];
            var exist = new Set();
            var minTimeInMinutes = -1;
            var maxTimeInMinutes = -1;
            if (this.minTime)
                minTimeInMinutes = this.parseTimeToMinutes(this.minTime);
            if (this.maxTime)
                maxTimeInMinutes = this.parseTimeToMinutes(this.maxTime);
            if (this.showMeridian) {
                var hourOrder = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
                for (var _i = 0, _a = ['AM', 'PM']; _i < _a.length; _i++) {
                    var meridian = _a[_i];
                    for (var _b = 0, hourOrder_1 = hourOrder; _b < hourOrder_1.length; _b++) {
                        var h = hourOrder_1[_b];
                        for (var _c = 0, _d = this.dropdownMinuteSteps; _c < _d.length; _c++) {
                            var m = _d[_c];
                            var currentTimeInMinutes = this.parse12HourTimeToMinutes(h, parseInt(m), meridian);
                            if (minTimeInMinutes >= 0 && currentTimeInMinutes < minTimeInMinutes)
                                continue;
                            if (maxTimeInMinutes >= 0 && currentTimeInMinutes > maxTimeInMinutes)
                                continue;
                            var timeStr = h.toString().padStart(2, '0') + ":" + m;
                            if (exist.has(timeStr))
                                continue;
                            exist.add(timeStr);
                            list.push(timeStr);
                        }
                    }
                }
            }
            else {
                for (var h = 0; h < 24; h++) {
                    for (var _e = 0, _f = this.dropdownMinuteSteps; _e < _f.length; _e++) {
                        var m = _f[_e];
                        var currentTimeInMinutes = h * 60 + parseInt(m);
                        if (minTimeInMinutes >= 0 && currentTimeInMinutes < minTimeInMinutes)
                            continue;
                        if (maxTimeInMinutes >= 0 && currentTimeInMinutes > maxTimeInMinutes)
                            continue;
                        list.push(h.toString().padStart(2, '0') + ":" + m);
                    }
                }
            }
            return list;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parse time string to minutes since midnight
     */
    NewTimePickerComponent.prototype.parseTimeToMinutes = function (timeStr) {
        if (!timeStr)
            return -1;
        timeStr = timeStr.trim();
        // Check for 12-hour format with AM/PM
        var match12 = timeStr.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
        if (match12) {
            var hour = parseInt(match12[1], 10);
            var minute = parseInt(match12[2], 10);
            var meridian = match12[3].toUpperCase();
            return this.parse12HourTimeToMinutes(hour, minute, meridian);
        }
        // Check for 24-hour format
        var match24 = timeStr.match(/^(\d{1,2}):(\d{2})$/);
        if (match24) {
            var hour = parseInt(match24[1], 10);
            var minute = parseInt(match24[2], 10);
            return hour * 60 + minute;
        }
        return -1;
    };
    /**
     * Convert 12-hour time to minutes since midnight
     */
    NewTimePickerComponent.prototype.parse12HourTimeToMinutes = function (hour, minute, meridian) {
        if (meridian === 'PM' && hour !== 12) {
            hour += 12;
        }
        else if (meridian === 'AM' && hour === 12) {
            hour = 0;
        }
        return hour * 60 + minute;
    };
    NewTimePickerComponent.prototype.openDropdown = function () {
        var _this = this;
        // Don't open dropdown if user is actively typing
        if (this.isTyping)
            return;
        this.showDropdown = true;
        this.showMeridianDropdown = false;
        // Auto-scroll to selected time after dropdown renders
        setTimeout(function () {
            _this.scrollToSelectedTime();
        }, 50); // Small delay to ensure DOM is rendered
    };
    /**
     * Handle focus on hour input - select all text for easy editing
     */
    NewTimePickerComponent.prototype.onHourFocus = function (event) {
        var input = event.target;
        setTimeout(function () {
            input.select();
        }, 0);
    };
    /**
     * Handle click on hour input
     */
    NewTimePickerComponent.prototype.onHourClick = function () {
        // Don't interfere with typing
        if (this.isTyping)
            return;
        this.openDropdown();
    };
    /**
     * Handle focus on minute input - select all text for easy editing
     */
    NewTimePickerComponent.prototype.onMinuteFocus = function (event) {
        var input = event.target;
        setTimeout(function () {
            input.select();
        }, 0);
    };
    /**
     * Handle click on minute input
     */
    NewTimePickerComponent.prototype.onMinuteClick = function () {
        // Don't interfere with typing
        if (this.isTyping)
            return;
        this.openDropdown();
    };
    /**
     * Scroll dropdown to show the currently selected time
     */
    NewTimePickerComponent.prototype.scrollToSelectedTime = function () {
        var dropdownElement = this.eRef.nativeElement.querySelector('.dropdown-values');
        if (!dropdownElement)
            return;
        var currentTime = this.hour + ":" + this.minute;
        var items = dropdownElement.querySelectorAll('.dropdown-item');
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var itemText = item.textContent ? item.textContent.trim() : '';
            if (itemText === currentTime) {
                // Calculate scroll position to center the item
                var itemHeight = item.offsetHeight;
                var dropdownHeight = dropdownElement.clientHeight;
                var scrollTop = item.offsetTop - (dropdownHeight / 2) + (itemHeight / 2);
                // Scroll to the calculated position
                dropdownElement.scrollTop = scrollTop;
                break;
            }
        }
    };
    NewTimePickerComponent.prototype.chooseTime = function (value) {
        var _a = value.split(':'), h = _a[0], m = _a[1];
        this.hour = h;
        this.minute = m;
        this.showDropdown = false;
        this.checkAndSnapRange();
    };
    NewTimePickerComponent.prototype.onHourInput = function (event) {
        this.isTyping = true;
        this.showDropdown = false;
        var input = event.target;
        var value = input.value.replace(/\D/g, ''); // Remove non-digits
        // If the input was cleared, allow typing
        if (value.length === 0) {
            this.hour = '';
            return;
        }
        // Validate and limit hour input
        if (this.showMeridian) {
            // 12-hour format: 01-12
            if (value.length === 1) {
                var digit = parseInt(value);
                if (digit > 1) {
                    value = '0' + digit;
                    this.hour = value;
                    this.focusMinuteInput();
                    return;
                }
            }
            else if (value.length >= 2) {
                value = value.substring(0, 2);
                var num = parseInt(value);
                if (num === 0)
                    num = 12;
                else if (num > 12)
                    num = 12;
                value = num.toString().padStart(2, '0');
                this.hour = value;
                this.focusMinuteInput();
                return;
            }
        }
        else {
            // 24-hour format: 00-23
            if (value.length === 1) {
                var digit = parseInt(value);
                if (digit > 2) {
                    value = '0' + digit;
                    this.hour = value;
                    this.focusMinuteInput();
                    return;
                }
            }
            else if (value.length >= 2) {
                value = value.substring(0, 2);
                var num = parseInt(value);
                if (num > 23)
                    num = 23;
                value = num.toString().padStart(2, '0');
                this.hour = value;
                this.focusMinuteInput();
                return;
            }
        }
        this.hour = value;
        if (this.hour.length === 2 && this.minute.length === 2) {
            this.emitFinalValue();
        }
    };
    NewTimePickerComponent.prototype.onMinuteInput = function (event) {
        this.isTyping = true;
        this.showDropdown = false;
        var input = event.target;
        var value = input.value.replace(/\D/g, ''); // Remove non-digits
        // If the input was cleared, allow typing
        if (value.length === 0) {
            this.minute = '';
            return;
        }
        // Validate and limit minute input
        if (value.length === 1) {
            var digit = parseInt(value);
            if (digit > 5) {
                value = '0' + digit;
                this.minute = value;
                return;
            }
        }
        else if (value.length >= 2) {
            value = value.substring(0, 2);
            var num = parseInt(value);
            if (num > 59)
                num = 59;
            value = num.toString().padStart(2, '0');
        }
        this.minute = value;
        if (this.hour.length === 2 && this.minute.length === 2) {
            this.emitFinalValue();
        }
    };
    NewTimePickerComponent.prototype.isWithinTimeRange = function () {
        if (!this.minTime && !this.maxTime)
            return true;
        var h = parseInt(this.hour, 10);
        var m = parseInt(this.minute, 10);
        var currentMinutes = this.showMeridian
            ? this.parse12HourTimeToMinutes(h, m, this.meridian)
            : h * 60 + m;
        if (this.minTime) {
            var minMinutes = this.parseTimeToMinutes(this.minTime);
            if (currentMinutes < minMinutes)
                return false;
        }
        if (this.maxTime) {
            var maxMinutes = this.parseTimeToMinutes(this.maxTime);
            if (currentMinutes > maxMinutes)
                return false;
        }
        return true;
    };
    NewTimePickerComponent.prototype.checkAndSnapRange = function () {
        if (!this.minTime && !this.maxTime) {
            this.emitFinalValue();
            return;
        }
        if (!this.isWithinTimeRange()) {
            this.snapToNearestValidTime();
        }
        else {
            this.emitFinalValue();
        }
    };
    NewTimePickerComponent.prototype.snapToNearestValidTime = function () {
        var h = parseInt(this.hour, 10);
        var m = parseInt(this.minute, 10);
        var minMinutes = this.minTime ? this.parseTimeToMinutes(this.minTime) : 0;
        var maxMinutes = this.maxTime ? this.parseTimeToMinutes(this.maxTime) : 24 * 60;
        if (this.showMeridian) {
            var oppositeMeridian = this.meridian === 'AM' ? 'PM' : 'AM';
            var oppositeMinutes = this.parse12HourTimeToMinutes(h, m, oppositeMeridian);
            if (oppositeMinutes >= minMinutes && oppositeMinutes <= maxMinutes) {
                this.meridian = oppositeMeridian;
                this.emitFinalValue();
                return;
            }
        }
        var currentMinutes = this.showMeridian
            ? this.parse12HourTimeToMinutes(h, m, this.meridian)
            : h * 60 + m;
        if (currentMinutes < minMinutes) {
            this.applyIncomingTime(this.minTime);
            this.emitFinalValue();
            return;
        }
        if (currentMinutes > maxMinutes) {
            this.applyIncomingTime(this.maxTime);
            this.emitFinalValue();
            return;
        }
        this.emitFinalValue();
    };
    NewTimePickerComponent.prototype.onHourKeydown = function (event) {
        var input = event.target;
        // If user types a digit and text is selected, clear and start fresh
        if (/^\d$/.test(event.key)) {
            var hasSelection = input.selectionStart !== input.selectionEnd;
            if (hasSelection) {
                event.preventDefault();
                this.hour = event.key;
                input.value = event.key;
                // Trigger input event manually
                var inputEvent = new Event('input', { bubbles: true });
                input.dispatchEvent(inputEvent);
                return;
            }
        }
        // Handle backspace
        if (event.key === 'Backspace') {
            if (input.value.length === 0) {
                event.preventDefault();
                return;
            }
            return;
        }
        // Handle delete key
        if (event.key === 'Delete') {
            return;
        }
        // Handle arrow right - move to minutes
        if (event.key === 'ArrowRight' && input.selectionStart === input.value.length) {
            event.preventDefault();
            this.focusMinuteInput();
            return;
        }
        // Handle colon - move to minutes
        if (event.key === ':') {
            event.preventDefault();
            this.focusMinuteInput();
            return;
        }
        // Only allow numeric input
        if (!/^\d$/.test(event.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
            event.preventDefault();
        }
    };
    NewTimePickerComponent.prototype.onMinuteKeydown = function (event) {
        var input = event.target;
        // If user types a digit and text is selected, clear and start fresh
        if (/^\d$/.test(event.key)) {
            var hasSelection = input.selectionStart !== input.selectionEnd;
            if (hasSelection) {
                event.preventDefault();
                this.minute = event.key;
                input.value = event.key;
                // Trigger input event manually
                var inputEvent = new Event('input', { bubbles: true });
                input.dispatchEvent(inputEvent);
                return;
            }
        }
        // Handle backspace - smart deletion flow
        if (event.key === 'Backspace') {
            var cursorPosition = input.selectionStart;
            var hasSelection = input.selectionStart !== input.selectionEnd;
            var valueLength = input.value.length;
            // If all text is selected, clear and stay in minute field
            if (hasSelection && input.selectionStart === 0 && input.selectionEnd === valueLength) {
                this.minute = '';
                event.preventDefault();
                return;
            }
            // If cursor is at position 0 (start of field) and no selection
            if (cursorPosition === 0 && !hasSelection) {
                event.preventDefault();
                // If minute has content, just move to hour without deleting
                if (valueLength > 0) {
                    this.focusHourInput();
                    return;
                }
                // If minute is empty, delete last character from hour and move focus
                if (this.hour.length > 0) {
                    this.hour = this.hour.slice(0, -1);
                }
                this.focusHourInput();
                return;
            }
            return;
        }
        // Handle delete key
        if (event.key === 'Delete') {
            if (input.selectionStart === 0 && input.selectionEnd === input.value.length) {
                this.minute = '';
                event.preventDefault();
            }
            return;
        }
        // Handle arrow left - move to hour if at start
        if (event.key === 'ArrowLeft' && input.selectionStart === 0) {
            event.preventDefault();
            this.focusHourInput();
            return;
        }
        // Only allow numeric input
        if (!/^\d$/.test(event.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
            event.preventDefault();
        }
    };
    NewTimePickerComponent.prototype.focusHourInput = function () {
        var _this = this;
        if (this.hourInput) {
            setTimeout(function () {
                _this.hourInput.nativeElement.focus();
                _this.hourInput.nativeElement.setSelectionRange(_this.hourInput.nativeElement.value.length, _this.hourInput.nativeElement.value.length);
            }, 0);
        }
    };
    NewTimePickerComponent.prototype.focusMinuteInput = function () {
        var _this = this;
        if (this.minuteInput) {
            setTimeout(function () {
                _this.minuteInput.nativeElement.focus();
                // Select all text in minute input so typing replaces it
                _this.minuteInput.nativeElement.select();
            }, 0);
        }
    };
    NewTimePickerComponent.prototype.onBlur = function () {
        this.normalizeTime();
        this.isTyping = false;
    };
    NewTimePickerComponent.prototype.normalizeTime = function () {
        var h = parseInt(this.hour || '0', 10);
        var m = parseInt(this.minute || '0', 10);
        if (this.showMeridian) {
            if (h === 0)
                h = 12;
            h = Math.min(Math.max(h, 1), 12);
        }
        else {
            h = Math.min(Math.max(h, 0), 23);
        }
        m = Math.min(Math.max(m, 0), 59);
        this.hour = h.toString().padStart(2, '0');
        this.minute = m.toString().padStart(2, '0');
        this.checkAndSnapRange();
    };
    NewTimePickerComponent.prototype.onMeridianOpen = function () {
        this.showDropdown = false;
        this.isTyping = false;
    };
    NewTimePickerComponent.prototype.toggleMeridianDropdown = function () {
        this.showDropdown = false;
        this.showMeridianDropdown = !this.showMeridianDropdown;
    };
    NewTimePickerComponent.prototype.selectMeridian = function (value) {
        this.meridian = value;
        this.showMeridianDropdown = false;
        this.checkAndSnapRange();
    };
    return NewTimePickerComponent;
}());
export { NewTimePickerComponent };
